export default "__VITE_ASSET__Cg0sLc0n__"